import { render, staticRenderFns } from "./MemberTermsContent.vue?vue&type=template&id=0f61e2d1&"
import script from "./MemberTermsContent.vue?vue&type=script&lang=ts&"
export * from "./MemberTermsContent.vue?vue&type=script&lang=ts&"
import style0 from "./MemberTermsContent.vue?vue&type=style&index=0&id=0f61e2d1&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
